import React from 'react'
import { ArrowBackIcon } from '@chakra-ui/icons'
import { Box, Checkbox, Heading, IconButton, Input, Modal, ModalBody, ModalContent, ModalOverlay, Text } from '@chakra-ui/react'
import CustomButton from '../../../elements/customButton'

export default function SendSMSDialog(props) {

    const PopupBox = () => (
        <Box className='wallet_popup'>
            <ModalOverlay />
            <ModalContent>
                <Box className='d-flex align-items-center justify-content-start col-gap-15 preference_header'>
                    <IconButton onClick={props.handleCloseSendSMS}><ArrowBackIcon /></IconButton>
                    <Heading as="h3" className="font-poppins">Send Recovery SMS</Heading>
                </Box>
                <ModalBody className='wallet_body'>
                    <Box className='add_funds_box' mt={1}>
                        <Heading as="h5" className='font-poppins recovery-text'>Please Enter Recovery Amount</Heading>
                        <Box pt={3} pb={3}>
                            <Box className='amount_input_container'>
                                <Box className='amount_input_box_withdraw' mb={1}>
                                    <Input
                                        type="number"
                                        size="md"
                                        name="amount"
                                        placeholder={"₹ 0.00"}
                                        onChange={props.handleChange}
                                        className="amount_input color-dark font-poppins"
                                        value={props?.inputValues?.amount ?? ''}
                                    />
                                </Box>
                            </Box> 
                        </Box>
                        <CustomButton size="md" type="submit" title="Send SMS" className="font-poppins btn_theme w-100" onClick={props.handleWithdrawAmount} />
                    </Box>
                </ModalBody>
            </ModalContent>
        </Box>
    )

  return (
    <Modal
        isCentered
        onClose={props.handleCloseSendSMS}
        isOpen={props.openSendSMS}
        motionPreset="slideInBottom"
        size={'sm'}
    >
    {PopupBox()}
    </Modal>
  )
}
